// jquery
$(document).ready(() => {
  const isRTL = $('#content-wrapper').attr('dir') === 'rtl';
  // init slick
  $('.reviews__list').slick({
    infinite: false,
    mobileFirst: true,
    variableWidth: true,
    rtl: isRTL,
    prevArrow: '.reviews__prev',
    nextArrow: '.reviews__next',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1439,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });
});
